import i18n from 'segments/i18n';

import { Role } from '../store/types';

export const roles: Role[] = ['user', 'admin', 'organization', 'operator', 'group', 'coach'];
export const rolesForEdit: Role[] = ['user', 'admin', 'coach'];

export const rolesTitles: Record<Role, string> = {
  user: i18n.t('roles.user', 'Пользователь'),
  admin: i18n.t('roles.admin', 'Администратор'),
  organization: i18n.t('roles.organization', 'Организация'),
  operator: i18n.t('roles.operator', 'Оператор'),
  coach: i18n.t('roles.coach', 'Тренер'),
  group: i18n.t('roles.group', 'Группа'),
};
